import React from 'react';
import { shape, string, arrayOf } from 'prop-types';
import classnames from 'classnames';
import { StyledLabel } from '@vpp-frontend-components/styled-label';
import VehicleInspectionAttribute from '../vehicle-inspection-attribute';

const namespace = 'ui-pdp-vehicle-inspection-row';

const VehicleInspectionRow = ({ title, sections }) => (
  <div className={classnames(namespace)}>
    <StyledLabel as="h2" {...title} />

    <div className={`${namespace}__specs-list`}>
      {sections[0]?.attributes[0]?.label &&
        sections[0].attributes.map(attr => <VehicleInspectionAttribute key={attr.label.text} {...attr} />)}
    </div>
  </div>
);

VehicleInspectionRow.propTypes = {
  title: shape({
    text: string.isRequired,
    color: string,
    font_size: string,
    font_family: string,
  }).isRequired,
  sections: arrayOf(
    shape({
      attributes: arrayOf(
        shape({
          icon: shape({
            id: string.isRequired,
            color: string,
            size: string,
          }),
          label: shape({
            text: string.isRequired,
            color: string,
            font_size: string,
            font_family: string,
            values: shape({
              value_text: shape({
                text: string,
                color: string,
                font_size: string,
                font_family: string,
              }),
            }),
          }),
        }),
      ),
    }),
  ).isRequired,
};

export default React.memo(VehicleInspectionRow);
